export default {
  type: 'nl-NL',
  confirming: 'Bevestigen...',
  paymentInfo:
    'Het eerste maandbedrag wordt afgeschreven nadat de fiets geleverd of opgehaald is.',
  errors: {
    processing:
      'Oeps! 🚧 Je verzoek is een omweg ingeslagen. Laten we het nog eens proberen! Als het nog steeds niet werkt, staat ons supportteam klaar om te helpen.',
    bike_not_available:
      'Het lijkt erop dat de fiets die je geselecteerd hebt nét door iemand anders besteld is. Helaas is die daarom niet meer beschikbaar! Kies een andere fiets om door te gaan'
  },
  statusMessage:
    'Helaas heb je op dit moment geen actief abonnement in jouw account staan. Klopt dit niet of heb je vragen over (het wisselen van) een fiets? Neem dan contact met ons op via <a>support@bikeflip.nl</a> of <strong>030-2271921</strong>.',
  bikeTitles: {
    prev: 'Vorige fiets',
    current: 'Huidige fiets',
    new: 'Nieuwe fiets'
  },
  currentBike: {
    month: 'maand'
  },
  emptyDescription: {
    '404Bikes': 'Geen fietsen gevonden',
    '404Details': 'Geen details gevonden'
  },
  productSelection: {
    title: 'Selecteer een fiets',
    description:
      'Je hebt maar één fiets in dit abonnement, dus hebben we die al voor je geselecteerd'
  },
  flip: {
    title: "'Flip' je fiets!",
    title_in_page: 'Fiets te klein of tijd om te flippen?',
    button: "Vraag een 'flip' aan",
    confirmationMessage:
      'We gaan direct voor je aan de slag! Je ontvangt nog een bevestiging van de flip-aanvraag per mail.'
  },
  add: {
    title: 'Voeg een extra fiets toe',
    intro:
      'Hier kun je een extra fiets toevoegen aan je account. Als jullie je huidige fiets willen flippen naar een andere fiets, gebruik dan de flip-functie',
    title_in_page: 'Nog een fiets nodig?',
    button: 'Fiets toevoegen',
    confirmationMessage:
      'We gaan direct voor je aan de slag! Je ontvangt binnenkort een bevestiging via e-mail.'
  },
  return: {
    title: 'Fietsen retourneren',
    charge_day:
      'Je abonnement wordt verlengd op <strong>{{- day}}</strong>. Je mag de fietsen tot die datum houden.',
    outside_service_area:
      'Je bevindt je buiten het servicegebied. Je kunt de fiets inleveren bij onze conceptstore.',
    address: 'Adres: <strong>{{address}}</strong>',
    opening_times: 'Openingstijden:',
    dropoff_text:
      'Je kunt de fiets op elk gewenst moment inleveren binnen de openingstijden van de winkel.',
    steps: {
      choose_bike: 'Kies een fiets om te retourneren',
      select_reason: 'Selecteer een reden',
      choose_pickup_dropoff: 'Kies een inleverlocatie',
      confirm: 'Bevestigen'
    },
    reasons: {
      have_bigger_bike: 'We hebben al een grotere maat fiets',
      given_bike: 'We hebben een fiets gekregen',
      disappointing_quality: 'De kwaliteit van de fiets viel tegen',
      other: 'Anders'
    },
    pickup_confirmation_text:
      'We staan bij je voor de deur op {{- pickupDateTime}}',
    dropoff_confirmation_text:
      'Je hebt ervoor gekozen om de fiets in te leveren bij onze conceptstore in {{dropoff_location}}.',
    confirm_outro: 'Je ontvangt van ons een bevestigingsmail.',
    in_progress: 'Return in progress'
  },
  day: {
    ma: 'Maandag',
    di: 'Dinsdag',
    wo: 'Woensdag',
    do: 'Donderdag',
    vr: 'Vrijdag',
    za: 'Zaterdag'
  },
  steps: {
    continue: 'Verder',
    flip: {
      title: 'Kies je nieuwe fiets',
      selectSize: 'Welke maat fiets?',
      description:
        'Heb je hulp nodig bij het kiezen van de juiste maat? Bekijk hier onze maattabel!',
      selectInput: {
        sizePlaceHolder: '--Selecteer een maat--'
      }
    },
    add: {
      title: '',
      selectSize: 'Welke maat fiets?',
      description:
        'Heb je hulp nodig bij het kiezen van de juiste maat? Bekijk hier onze maattabel!',
      selectInput: {
        sizePlaceHolder: '--Selecteer een maat--'
      }
    },
    sizeBike: {
      description: {
        currentSize: 'Huidige maat: ',
        text: 'Heb je hulp nodig bij het kiezen van de juiste maat? Bekijk hier ',
        link: {
          text: 'onze maattabel',
          url: 'https://bikeflip.nl/pages/kinderfiets-maattabel'
        },
        reasonText: 'Wat is de reden van de flip?'
      },
      selectInput: {
        sizePlaceHolder: '--Selecteer een maat--',
        sizeValues: {
          12: '12 inch: 2-4 jaar',
          14: '14 inch: 3-5 jaar',
          16: '16 inch: 4-6 jaar',
          18: '18 inch: 6-7 jaar',
          20: '20 inch: 7-8 jaar',
          22: '22 inch: 8-9 jaar',
          24: '24 inch: 9-10 jaar',
          26: '26 inch: 10-12 jaar',
          28: '28 inch: > 12 jaar',
          L: 'Loopfiets: < 3 jaar'
        },
        reasonPlaceHolder: '--Reden van de flip--',
        reasonOtherPlaceHolder: 'Graag toelichten',
        reasonValues: {
          small: 'Fiets is te klein geworden',
          broken: 'Fiets is kapot',
          unsatisfied: 'Niet tevreden',
          other: 'Anders'
        }
      },
      advised: 'geadviseerd'
    },
    selectBike: {
      title: 'Kies je nieuwe fiets!',
      description: {
        textPrefix:
          'Wil je nog even uitgebreid de fietsen bekijken? Ga dan naar ',
        textSuffix: 'en voer hier daarna gekozen fietsnummer in.'
      },
      searchBar: {
        placeholder: 'Zoek een fiets'
      },
      infobox: {
        url: 'https://bikeflip.nl/collections'
      },
      modal: {
        title: 'Fiets specificaties',
        button: 'Kies deze fiets'
      }
    },
    deliveryMoment: {
      title: 'Maak een afspraak',
      subTitle: 'Laten bezorgen of zelf ophalen?',
      address: {
        changeLabel: 'Adres aanpassen',
        modal: {
          title: 'Adres gegevens',
          ok: 'Aanpassen',
          cancel: 'Annuleren',
          info: 'Als je hier het adres wijzigt, zal ook het standaard adres in je account wijzigen.',
          form: {
            address: {
              label: 'Adres',
              rules: {
                required: 'Straat naam is verplicht.',
                maxLength: 'Straat is langer dan 70 karakters.'
              }
            },
            houseNr: {
              rules: {
                required: 'Huisnummer is verplicht.',
                maxLength: 'Huisnummer is langer dan 70 karakters.'
              }
            },
            postalCode: {
              label: 'Postcode',
              rules: {
                required: 'Postcode is verplicht.',
                pattern: 'vul een geldige postcode. Bijv. 0000AB'
              }
            },
            city: {
              label: 'Stad',
              rules: {
                required: 'Stad is verplicht.',
                maxLength: 'Stad is langer dan 50 karakters.'
              }
            }
          }
        }
      },
      fulfillmentType: {
        description: {
          prefix: 'Bekijk het',
          middle: 'bezorggebied',
          link: 'https://bikeflip.nl/pages/bezorggebied',
          suffix: ' en zie wat dit voor jou betekent.'
        },
        delivery: {
          title: 'Bezorgen',
          description:
            'Klik en kies welke dag en tijdstip jou het beste uitkomt.',
          within_service_area: 'We bezorgen alleen binnen het servicegebied',
          current_address: 'Je opgegeven adres lijkt te zijn {{address}}'
        },
        pickup: {
          title: 'Ophalen',
          description:
            'Klik en kies welke locatie en welk moment jou het beste uitkomt.',
          donation_description:
            'Klik en kies het moment dat jou het beste uitkomt, we komen dan bij je ophalen.'
        },
        dropoff: {
          title: 'Inleveren',
          description:
            'Klik en kies welke locatie en welk moment jou het beste uitkomt.'
        }
      },
      calendar: {
        title: 'Welk moment schikt jou?',
        selectedMoment: {
          prefix: 'Gekozen moment: ',
          middle: ' op ',
          suffix: ' tussen '
        },
        modal: {
          title: 'Tijdslot',
          subTitle: 'Wanneer komt het beste uit op',
          ok: 'Selecteren',
          cancel: 'Annuleren'
        },
        button: 'Ga naar bevestigen'
      },
      areaMessage:
        'Het opgegeven adres ligt buiten ons huidige servicegebied, maar je kunt de fiets <strong>de volgende werkdag bij ons ophalen</strong>!'
    },
    confirmation: {
      title: 'Controleer en bevestig',
      description:
        '<p>Check wel je gegevens nog even goed, zodat we de bestelling goed kunnen afhandelen. Je ontvangt binnenkort een bevestigingsmail met alle details.</p>',
      button: 'Bevestig'
    }
  },
  donation: {
    thankYou: {
      title: 'Bedankt voor je donatie!',
      description:
        'Onwijs bedankt voor je donatie! We sturen je een email met verdere instructies.'
    },
    fields: {
      email: {
        label: 'E-mailadres',
        placeholder: 'E-mailadres',
        required: 'Vul je e-mailadres in',
        invalid: 'Ongeldig e-mailadres'
      },
      phone: {
        label: 'Telefoonnummer',
        placeholder: 'Telefoonnummer',
        required: 'Vul je telefoonnummer in'
      },
      firstName: {
        label: 'Voornaam',
        placeholder: 'Voornaam',
        required: 'Vul je voornaam in'
      },
      lastName: {
        label: 'Achternaam',
        placeholder: 'Achternaam',
        required: 'Vul je achternaam in'
      },
      street: {
        label: 'Straat',
        placeholder: 'Straat',
        required: 'Vul je straat in'
      },
      houseNumber: {
        label: 'Huisnummer',
        placeholder: 'Huisnummer',
        required: 'Vul je huisnummer in'
      },
      postalCode: {
        label: 'Postcode',
        placeholder: 'Postcode',
        required: 'Vul je postcode in'
      },
      city: {
        label: 'Woonplaats',
        placeholder: 'Woonplaats',
        required: 'Vul je woonplaats in'
      }
    },
    bikeSize: {
      label: 'Soort fiets',
      placeholder: 'Selecteer welke soort fiets je wilt doneren',
      required: 'Kies welke soort fiets je wilt doneren',
      options: {
        loopfiets: 'Loopfiets',
        child22: 'Kinderfiets t/m 22 inch',
        size24: 'Fiets vanaf 24 inch'
      }
    },
    quantity: {
      label: 'Aantal fietsen',
      required: 'Kies hoeveel fietsen je wilt doneren',
      moreThan15: 'Meer dan 15'
    },
    pickupDate: {
      label: 'Ophaaldatum',
      required: 'Kies een datum'
    },
    outsideDeliveryArea: 'Helaas, deze postcode valt buiten ons bezorggebied.',
    chosenDateLabel: 'Gekozen datum:',
    submit: 'Doneer je fiets'
  },
  feedback: {
    title: 'Feedback? Laat het ons weten!',
    placeholder: 'We horen graag jullie ervaringen, ideeën of bevindingen',
    submit: 'Deel',
    submitted: 'Bedankt voor je feedback 💚'
  },
  stolenBike: 'Is je fiets gestolen?'
};
